import React from "react"
import stopPropagation from "../../../../core/gd/utils/stop-propagation";
import Classes from "classnames";
import {ModalPlacement} from "./@types";

type Props = {
    className?      : string,
    children        : any
    style?          : style

    placement?      : ModalPlacement

}

export default function ModalV5(props:Props)  {

    const placement = props.placement || ModalPlacement.MIDDLE

    const classes = Classes("v5-container", props.className, {
        'placement-middle'      : placement === ModalPlacement.MIDDLE,
        'placement-top'         : placement === ModalPlacement.TOP,
    })

    return (
        <div className={classes} onClick={stopPropagation} style={props.style}>

            {props.children}

        </div>
    )
}
